export const BADGE_SIZES = {
  standard: { width: 54, height: 86, name: 'Standard (54x86mm)' },
  large: { width: 76, height: 105, name: 'Large (76x105mm)' },
  small: { width: 45, height: 70, name: 'Small (45x70mm)' },
  square: { width: 76, height: 76, name: 'Square (76x76mm)' },
};

export const FONT_FAMILIES = [
  { value: 'Arial, sans-serif', label: 'Arial' },
  { value: 'Helvetica, sans-serif', label: 'Helvetica' },
  { value: 'Georgia, serif', label: 'Georgia' },
  { value: 'Times New Roman, serif', label: 'Times New Roman' },
  { value: 'Courier New, monospace', label: 'Courier New' },
  { value: 'Verdana, sans-serif', label: 'Verdana' },
];

export const DEFAULT_DESIGN = {
  size: 'standard',
  orientation: 'portrait',
  layout: 'centered',
  // Kept in step with backend DEFAULT_BADGE_DESIGN so both halves agree on
  // what counts as "untouched" (and therefore inherits event branding).
  primaryColor: '#3B82F6',
  secondaryColor: '#1E40AF',
  backgroundColor: '#ffffff',
  textColor: '#1f2937',
  fontFamily: 'Arial, sans-serif',
  nameSize: 16,
  companySize: 12,
  titleSize: 10,
  showLogo: true,
  showEventName: true,
  showQrCode: true,
  qrSize: 80,
  showCompany: true,
  showTitle: true,
  showTier: true,
  tierPosition: 'top',
  showBadgeId: true,
  borderRadius: 8,
  headerStyle: 'gradient',
  backgroundImage: null,
  backgroundImageUrl: '',
  backgroundOpacity: 100,
  backgroundFit: 'cover',
};
